import BrandIndex from "../pages/brand/BrandIndex";
import AddBrand from "../pages/brand/AddBrand";
import EditBrand from "../pages/brand/EditBrand";

const brandRoutes = [
  {
    path: "brands",
    element: <BrandIndex />,
  },
  {
    path: "brands/add",
    element: <AddBrand />,
  },
  {
    path: "brands/edit/:id",
    element: <EditBrand />,
  },
];

export default brandRoutes;